import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const res = await api.post("/auth/google-session", { session_id: sessionId });
        setUser(res.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        const u = res.data.user;
        if (u.role === "admin") navigate("/admin", { replace: true, state: { user: u } });
        else if (!u.onboarding_completed) navigate("/onboarding", { replace: true, state: { user: u } });
        else navigate("/portal", { replace: true, state: { user: u } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#060D1F] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
